import { Component, OnInit, Renderer2 } from '@angular/core';
import { AuthenticationService } from '../_services';
import { HomeService } from '../_services/home.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { DomSanitizer } from '@angular/platform-browser';
import { GoogleAnalyticsService } from '../_services/google-analytics.service';
export let checkCaseModalInHelpCenter = false;

class TrackerCaseCreation {
  trackerData: string;
  trackerTitle: string;
  trackerType: string;
  userPk: any;
};

@Component({
  selector: 'app-tracker',
  templateUrl: './tracker.component.html',
  styleUrls: ['./tracker.component.scss']
})
export class TrackerComponent implements OnInit {
  myHelpCenterConfigurationOptionLabel: Array<any>;
  helpCenterLabel: boolean = false;
  header: any;
  linkText: Array<any>;
  caseAlertMessage: string;
  alert: boolean = false;
  delayed: boolean = false;
  searchBanner: any;
  searchTextboxNote: any;
  searchTextboxHover: any;
  searchButtonHover: any;
  selectedValue: any;
  selectedValueFA1: any;
  selectedValueFA2: any;
  selectedValueSA: any;
  selectedValueAR: any;
  data: any[] = [];
  checkCaseModalInHelpCenter: boolean = false;
  isSmartViewChat: any;
  i18n: any;
  chatform: FormGroup
  showOnSelfHelp: boolean = false;
  configurations: any[] = [];
  showTrackerFA: boolean = false;
  showTrackerSA: boolean = false;
  showTrackerAR: boolean = false;
  trackerName: any;
  holderTrType: any;
  configTrType: any;
  phaseNumber: any;
  externalArticleId: any;
  disableFutureYearOnShp: any;
  phaseConfigurations: any[] = [];
  trackerConfigurations: any[] = [];
  holders: any[] = [];
  yearLabel: any;
  id: any;
  phaseDetails: any;
  faPhases: any[] = [];
  saPhases: any[] = [];
  arPhases: any[] = [];
  showFa1: boolean = false;
  showFa2: boolean = false;
  showSa: boolean = false;
  showAr: boolean = false;
  caseTitle: any;
  caseType: any;
  findOutMoreFA1: any;
  findOutMoreFA2: any;
  findOutMoreSA: any;
  findOutMoreAR: any;
  articleTitleFA1: any;
  articleTitleFA2: any;
  articleTitleSA: any;
  articleTitleAR: any;
  collapsedFA: boolean = false;
  collapsedFA1: boolean = false;
  collapsedFA2: boolean = false;
  collapsedSA: boolean = false;
  collapsedAR: boolean = false;
  createdTicket: any;
  appendedData: any;
  contact: any[] = [];
  result: any;
  key: any = [];
  count: any = 0;
  keys: any;
  val: any;
  disableLiveChatSHP: any;

  constructor(private authService: AuthenticationService, private homeService: HomeService, private router: Router, private formBuilder: FormBuilder, private spinner: NgxSpinnerService, private domSanitizer: DomSanitizer, private renderer: Renderer2, private gaService: GoogleAnalyticsService) { }

  ngOnInit() {
    this.getTrackerConfig();
    this.getTrackerData();
    this.gaService.updatePageName();
    // this.getPageTitle("Tracker");
    // if(this.id){
    //   console.log('Check what this id is : '+this.id);
    //   this.viewArticleFa(this.id);
    //   this.viewArticleSa(this.id);
    //   this.viewArticleAr(this.id);
    // }
    this.getTrackerPhaseData();

    this.homeService.getShpLogin().subscribe(res => {
      this.isSmartViewChat = res.return_body.is_smart_view_chat;
      this.disableLiveChatSHP = res.return_body.disable_live_chat_SHP
    })
    let autoChatOpen = this.authService.getValueInConfigFromLocalStorage('autoOpenChatWindow');
    if (autoChatOpen !== null && autoChatOpen === "yes") {
      this.homeService.openChat.next(true);
    }
    console.log('url', this.router.url)
    if (sessionStorage.getItem('i18n')) {
      this.i18n = JSON.parse(sessionStorage.getItem('i18n'));
    }
    this.chatform = this.formBuilder.group(
      {
        comment: ['', [Validators.required]],
      });

    let currentUser = JSON.parse(this.authService.getCurrentUser());
    if (currentUser !== null && currentUser.user !== null) {
      this.homeService.getHelpCenterConfiguration().subscribe(res => {
        this.myHelpCenterConfigurationOptionLabel = res.return_body.myHelpCenterOptionalLable
        this.helpCenterLabel = this.myHelpCenterConfigurationOptionLabel[0].labelEnabler
        // this.ticketListLabel = res.return_body.ticketListLabel
        // this.listSizeNotes = res.return_body.listSizeNotes
      })
      this.getHeaderConfig();
      this.caseMessage();
    } else {
      console.log("INSIDE ELSE BLOCK LOOPING");
      this.homeService.navigateToLogin(this.router.url);
    }
    this.kbSearchConfig();

  }

  getTrackerConfig() {
    this.homeService.trackerConfig().subscribe(res => {
      this.showOnSelfHelp = res.return_body.showOnSelfHelp;
    })
  }

  getTrackerPhaseData() {
    this.homeService.trackerPhaseDetail().subscribe(res => {
      this.phaseDetails = res.return_body;
      for (let trackerPhaseData of this.phaseDetails) {
        if (trackerPhaseData.trackerType == "FA") {
          this.faPhases = trackerPhaseData.phases;
        }
        if (trackerPhaseData.trackerType == "SA") {
          this.saPhases = trackerPhaseData.phases;
        }
        if (trackerPhaseData.trackerType == "AR" || "ARR") {
          this.arPhases = trackerPhaseData.phases;
        }
      }
    })
  }

  getTrackerData() {
    this.homeService.sendMessage(true);
    this.homeService.trackerData().subscribe(res => {
      this.holders = res.return_body.tracker_info.holders;
      this.trackerConfigurations = res.return_body.tracker_info.configrations;
      for (let config of this.trackerConfigurations) {
        if (config.tracker_type == "FA") {
          this.showTrackerFA = config.showOnSelfHelp;
          this.disableFutureYearOnShp = config.disable_future_year;
        }
        if (config.tracker_type == "SA") {
          this.showTrackerSA = config.showOnSelfHelp;
        }
        if (config.tracker_type == "AR" || "ARR") {
          this.showTrackerAR = config.showOnSelfHelp;
        }
      }
      this.homeService.sendMessage(false);
    }, error => {
      this.homeService.sendMessage(false);
      console.log("Failed to retrieve tracker data.");
    });
  }

  viewArticleFa1(id) {
    if (this.showFa1 == false)
        this.homeService.getViewArticles(id).subscribe(resp => {
        let article = resp.return_body.article;
        this.articleTitleFA1 = article.article_title;
        this.findOutMoreFA1 = article.article_content;
        if (this.findOutMoreFA1.includes("${runtime")) {
        this.homeService.getContact().subscribe(res => {
            this.contact = res.return_body;
            console.log("contact ", this.contact);
            let val = [];
            let contact = []
            contact = res.return_body;
            console.log("contact temp is ", contact);
            val = res.return_body.ute;

            console.log("value is", val)
            for (const line of this.findOutMoreFA1.split(/[\r\n]+/)) {
              if (line.includes("${runtime")) {
                this.count++;
                for (let value of val) {
                  value.registry_key = value.registry_key.replaceAll(" ", "_");
                  if (line.includes("${runtime.custom_" + value.registry_key)) {
                    if (!(value.attribute_type == "OPTION" || value.attribute_type == "MULTIOPTION")) {
                      console.log("value appended");
                      this.appendedData = this.findOutMoreFA1.replaceAll("${runtime.custom_" + value.registry_key + "}", value.field_value);
                      this.findOutMoreFA1 = this.appendedData;
                    }
                    else {
                     this.homeService.getCaller(value.id).subscribe(response => {
                        this.result = response.return_body;
                        for (let optionValue of this.result) {
                          if (value.attribute_type === "OPTION" && value.attribute_type != "MULTIOPTION") {
                            if (value.field_value.includes(optionValue.id.toString())) {
                              this.appendedData = this.findOutMoreFA1.replaceAll("${runtime.custom_" + value.registry_key + ".optionvalue" + "}", optionValue.option_value);
                              this.findOutMoreFA1 = this.appendedData;
                            }

                          }
                          if (value.attribute_type === "MULTIOPTION" && value.attribute_type != "OPTION") {
                            let tempValues = []
                            let temp = []
                            if (value.field_value.includes(",")) {
                              tempValues = tempValues.concat(value.field_value);
                              value.field_value.split(",")
                              for (let option of this.result) {
                                for (let field of tempValues) {
                                  if (field.includes(option.id.toString())) {
                                    temp = temp.concat(option.option_value);
                                  }
                                }
                              }
                              this.appendedData = this.findOutMoreFA1.replaceAll("${runtime.custom_" + value.registry_key + ".optionvalue" + "}", temp);
                              this.findOutMoreFA1 = this.appendedData;
                            }
                            else {
                              if (value.field_value.includes(optionValue.id.toString())) {
                                this.appendedData = this.findOutMoreFA1.replaceAll("${runtime.custom_" + value.registry_key + ".optionvalue" + "}", optionValue.option_value);
                                this.findOutMoreFA1 = this.appendedData;
                              }
                            }

                          }

                        }
                      this.showLessDataFA1(this.findOutMoreFA1);
                      });

                    }

                  }
                  if (line.includes("${runtime.caller_")) {
                    if (line.includes("${runtime.caller_firstname")) {
                      this.appendedData = this.findOutMoreFA1.replaceAll("${runtime.caller_firstname}", res.return_body.first_name);
                      this.findOutMoreFA1 = this.appendedData;

                    }
                    if (line.includes("${runtime.caller_lastname")) {
                      this.appendedData = this.findOutMoreFA1.replaceAll("${runtime.caller_lastname}", res.return_body.last_name);
                      this.findOutMoreFA1 = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_username")) {
                      this.appendedData = this.findOutMoreFA1.replaceAll("${runtime.caller_username}", res.return_body.user_name);
                      this.findOutMoreFA1 = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_email")) {
                      this.appendedData = this.findOutMoreFA1.replaceAll("${runtime.caller_email}", res.return_body.email);
                      this.findOutMoreFA1 = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_userid")) {
                      this.appendedData = this.findOutMoreFA1.replaceAll("${runtime.caller_userid}", res.return_body.user_id);
                      this.findOutMoreFA1 = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_phone")) {
                      this.appendedData = this.findOutMoreFA1.replaceAll("${runtime.caller_phone}", res.return_body.primary_phone);
                      this.findOutMoreFA1 = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_extra_userid")) {
                      this.appendedData = this.findOutMoreFA1.replaceAll("${runtime.caller_extra_userid}", res.return_body.extra_user_id);
                      this.findOutMoreFA1 = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_campus")) {
                      this.appendedData = this.findOutMoreFA1.replaceAll("${runtime.caller_campus}", res.return_body.campus);
                      this.findOutMoreFA1 = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_dob")) {
                      this.appendedData = this.findOutMoreFA1.replaceAll("${runtime.caller_dob}", res.return_body.dob);
                      this.findOutMoreFA1 = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_ssn")) {
                      this.appendedData = this.findOutMoreFA1.replaceAll("${runtime.caller_ssn}", res.return_body.ssn);
                      this.findOutMoreFA1 = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_password")) {
                      this.appendedData = this.findOutMoreFA1.replaceAll("${runtime.caller_password}", res.return_body.password);
                      this.findOutMoreFA1 = this.appendedData;
                    }
                  }
                }
              }
            }
          });
        }
        else {
          this.findOutMoreFA1 = article.article_content;
          this.showLessDataFA1(article.article_content);
        }

      });
  }

  viewArticleFa2(id) {
    if (this.showFa2 == false)
      this.homeService.getViewArticles(id).subscribe(res => {
        let article = res.return_body.article;
        this.articleTitleFA2 = article.article_title;
        this.findOutMoreFA2 = article.article_content;
        if (this.findOutMoreFA2.includes("${runtime")) {
          this.homeService.getContact().subscribe(res => {
            this.contact = res.return_body;
            console.log("contact ", this.contact);
            let val = [];
            let contact = []
            contact = res.return_body;
            console.log("contact temp is ", contact);
            val = res.return_body.ute;

            console.log("value is", val)
            for (const line of this.findOutMoreFA2.split(/[\r\n]+/)) {
              if (line.includes("${runtime")) {
                this.count++;
                for (let value of val) {
                  value.registry_key = value.registry_key.replaceAll(" ", "_");
                  if (line.includes("${runtime.custom_" + value.registry_key)) {
                    if (!(value.attribute_type == "OPTION" || value.attribute_type == "MULTIOPTION")) {
                      console.log("value appended");
                      this.appendedData = this.findOutMoreFA2.replaceAll("${runtime.custom_" + value.registry_key + "}", value.field_value);
                      this.findOutMoreFA2 = this.appendedData;
                    }
                    else {
                      this.homeService.getCaller(value.id).subscribe(response => {
                        this.result = response.return_body;
                        for (let optionValue of this.result) {
                          if (value.attribute_type === "OPTION" && value.attribute_type != "MULTIOPTION") {
                            if (value.field_value.includes(optionValue.id.toString())) {
                              this.appendedData = this.findOutMoreFA2.replaceAll("${runtime.custom_" + value.registry_key + ".optionvalue" + "}", optionValue.option_value);
                              this.findOutMoreFA2 = this.appendedData;
                            }

                          }
                          if (value.attribute_type === "MULTIOPTION" && value.attribute_type != "OPTION") {
                            let tempValues = []
                            let temp = []
                            if (value.field_value.includes(",")) {
                              tempValues = tempValues.concat(value.field_value);
                              value.field_value.split(",")
                              for (let option of this.result) {
                                for (let field of tempValues) {
                                  if (field.includes(option.id.toString())) {
                                    temp = temp.concat(option.option_value);
                                  }
                                }
                              }
                              this.appendedData = this.findOutMoreFA2.replaceAll("${runtime.custom_" + value.registry_key + ".optionvalue" + "}", temp);
                              this.findOutMoreFA2 = this.appendedData;
                            }
                            else {
                              if (value.field_value.includes(optionValue.id.toString())) {
                                this.appendedData = this.findOutMoreFA2.replaceAll("${runtime.custom_" + value.registry_key + ".optionvalue" + "}", optionValue.option_value);
                                this.findOutMoreFA2 = this.appendedData;
                              }
                            }

                          }

                        }
                        this.showLessDataFA1(this.findOutMoreFA2);
                      });

                    }

                  }
                  if (line.includes("${runtime.caller_")) {
                    if (line.includes("${runtime.caller_firstname")) {
                      this.appendedData = this.findOutMoreFA2.replaceAll("${runtime.caller_firstname}", res.return_body.first_name);
                      this.findOutMoreFA2 = this.appendedData;

                    }
                    if (line.includes("${runtime.caller_lastname")) {
                      this.appendedData = this.findOutMoreFA2.replaceAll("${runtime.caller_lastname}", res.return_body.last_name);
                      this.findOutMoreFA2 = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_username")) {
                      this.appendedData = this.findOutMoreFA2.replaceAll("${runtime.caller_username}", res.return_body.user_name);
                      this.findOutMoreFA2 = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_email")) {
                      this.appendedData = this.findOutMoreFA2.replaceAll("${runtime.caller_email}", res.return_body.email);
                      this.findOutMoreFA2 = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_userid")) {
                      this.appendedData = this.findOutMoreFA2.replaceAll("${runtime.caller_userid}", res.return_body.user_id);
                      this.findOutMoreFA2 = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_phone")) {
                      this.appendedData = this.findOutMoreFA2.replaceAll("${runtime.caller_phone}", res.return_body.primary_phone);
                      this.findOutMoreFA2 = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_extra_userid")) {
                      this.appendedData = this.findOutMoreFA2.replaceAll("${runtime.caller_extra_userid}", res.return_body.extra_user_id);
                      this.findOutMoreFA2 = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_campus")) {
                      this.appendedData = this.findOutMoreFA2.replaceAll("${runtime.caller_campus}", res.return_body.campus);
                      this.findOutMoreFA2 = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_dob")) {
                      this.appendedData = this.findOutMoreFA2.replaceAll("${runtime.caller_dob}", res.return_body.dob);
                      this.findOutMoreFA2 = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_ssn")) {
                      this.appendedData = this.findOutMoreFA2.replaceAll("${runtime.caller_ssn}", res.return_body.ssn);
                      this.findOutMoreFA2 = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_password")) {
                      this.appendedData = this.findOutMoreFA2.replaceAll("${runtime.caller_password}", res.return_body.password);
                      this.findOutMoreFA2 = this.appendedData;
                    }
                  }
                }
              }
            }
          });

        }
        else {
          this.showLessDataFA2(this.findOutMoreFA2);
        }
      });
  }

  showLessDataFA1(data) {
    this.selectedValueFA1 = data?.slice(0, 300);
    this.selectedValueFA1 = this.selectedValueFA1.substr(0, Math.min(this.selectedValueFA1.length, this.selectedValueFA1.lastIndexOf(" ")));
    this.selectedValueFA1 = this.sanitizeHTML(this.selectedValueFA1);
  }

  showLessDataFA2(data) {
    this.selectedValueFA2 = data?.slice(0, 300);
    this.selectedValueFA2 = this.selectedValueFA2.substr(0, Math.min(this.selectedValueFA2.length, this.selectedValueFA2.lastIndexOf(" ")));
    this.selectedValueFA2 = this.selectedValueFA2 + '...';
    this.selectedValueFA2 = this.sanitizeHTML(this.selectedValueFA2);
  }

  async toggleFindMoreFA1() {
    this.showFa1 = true;
    this.selectedValueFA1 = this.sanitizeHTML(this.findOutMoreFA1);
    this.createCase(this.selectedValueFA1, this.articleTitleFA1, "FA");
  }

  async toggleFindMoreFA2() {
    this.showFa2 = true;
    this.selectedValueFA2 = await this.sanitizeHTML(this.findOutMoreFA2);
    this.createCase(this.selectedValueFA2, this.articleTitleFA2, "FA");
    console.log("faa222....", this.selectedValueFA2);
    console.log('Failure is ' + this.selectedValueFA2 + ' And ' + this.findOutMoreFA2);
  }

  viewArticleSa(id) {
    if (this.showSa == false)
      this.homeService.getViewArticles(id).subscribe(res => {
        let article = res.return_body.article
        this.articleTitleSA = article.article_title;
        this.findOutMoreSA = article.article_content;
        if (this.findOutMoreSA.includes("${runtime")) {
          this.homeService.getContact().subscribe(res => {
            this.contact = res.return_body;
            console.log("contact ", this.contact);
            let val = [];
            let contact = []
            contact = res.return_body;
            console.log("contact temp is ", contact);
            val = res.return_body.ute;
            for (const line of this.findOutMoreSA.split(/[\r\n]+/)) {
              if (line.includes("${runtime")) {
                this.count++;
                for (let value of val) {
                  value.registry_key = value.registry_key.replaceAll(" ", "_");
                  if (line.includes("${runtime.custom_" + value.registry_key)) {
                    if (!(value.attribute_type == "OPTION" || value.attribute_type == "MULTIOPTION")) {
                      this.appendedData = this.findOutMoreSA.replaceAll("${runtime.custom_" + value.registry_key + "}", value.field_value);
                      this.findOutMoreSA = this.appendedData;
                    }
                    else {
                      this.homeService.getCaller(value.id).subscribe(response => {
                        this.result = response.return_body;
                        for (let optionValue of this.result) {
                          if (value.attribute_type === "OPTION" && value.attribute_type != "MULTIOPTION") {
                            if (value.field_value.includes(optionValue.id.toString())) {
                              this.appendedData = this.findOutMoreSA.replaceAll("${runtime.custom_" + value.registry_key + ".optionvalue" + "}", optionValue.option_value);
                              this.findOutMoreSA = this.appendedData;
                            }

                          }
                          if (value.attribute_type === "MULTIOPTION" && value.attribute_type != "OPTION") {
                            let tempValues = []
                            let temp = []
                            if (value.field_value.includes(",")) {
                              tempValues = tempValues.concat(value.field_value);
                              value.field_value.split(",")
                              for (let option of this.result) {
                                for (let field of tempValues) {
                                  if (field.includes(option.id.toString())) {
                                    temp = temp.concat(option.option_value);
                                  }
                                }
                              }
                              this.appendedData = this.findOutMoreSA.replaceAll("${runtime.custom_" + value.registry_key + ".optionvalue" + "}", temp);
                              this.findOutMoreSA = this.appendedData;
                            }
                            else {
                              if (value.field_value.includes(optionValue.id.toString())) {
                                this.appendedData = this.findOutMoreSA.replaceAll("${runtime.custom_" + value.registry_key + ".optionvalue" + "}", optionValue.option_value);
                                this.findOutMoreSA = this.appendedData;
                              }
                            }

                          }

                        }
                        this.showLessDataSA(this.findOutMoreSA);
                      });

                    }

                  }
                  if (line.includes("${runtime.caller_")) {
                    if (line.includes("${runtime.caller_firstname")) {
                      this.appendedData = this.findOutMoreSA.replaceAll("${runtime.caller_firstname}", res.return_body.first_name);
                      this.findOutMoreSA = this.appendedData;

                    }
                    if (line.includes("${runtime.caller_lastname")) {
                      this.appendedData = this.findOutMoreSA.replaceAll("${runtime.caller_lastname}", res.return_body.last_name);
                      this.findOutMoreSA = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_username")) {
                      this.appendedData = this.findOutMoreSA.replaceAll("${runtime.caller_username}", res.return_body.user_name);
                      this.findOutMoreSA = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_email")) {
                      this.appendedData = this.findOutMoreSA.replaceAll("${runtime.caller_email}", res.return_body.email);
                      this.findOutMoreSA = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_userid")) {
                      this.appendedData = this.findOutMoreSA.replaceAll("${runtime.caller_userid}", res.return_body.user_id);
                      this.findOutMoreSA = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_phone")) {
                      this.appendedData = this.findOutMoreSA.replaceAll("${runtime.caller_phone}", res.return_body.primary_phone);
                      this.findOutMoreSA = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_extra_userid")) {
                      this.appendedData = this.findOutMoreSA.replaceAll("${runtime.caller_extra_userid}", res.return_body.extra_user_id);
                      this.findOutMoreSA = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_campus")) {
                      this.appendedData = this.findOutMoreSA.replaceAll("${runtime.caller_campus}", res.return_body.campus);
                      this.findOutMoreSA = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_dob")) {
                      this.appendedData = this.findOutMoreSA.replaceAll("${runtime.caller_dob}", res.return_body.dob);
                      this.findOutMoreSA = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_ssn")) {
                      this.appendedData = this.findOutMoreSA.replaceAll("${runtime.caller_ssn}", res.return_body.ssn);
                      this.findOutMoreSA = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_password")) {
                      this.appendedData = this.findOutMoreSA.replaceAll("${runtime.caller_password}", res.return_body.password);
                      this.findOutMoreSA = this.appendedData;
                    }
                  }
                }
              }
            }
          });

        }
        else {
          this.showLessDataSA(article.article_content);
        }
      });
  }

  showLessDataSA(data) {
    this.selectedValueSA = data?.slice(0, 300);
    this.selectedValueSA = this.selectedValueSA.substr(0, Math.min(this.selectedValueSA.length, this.selectedValueSA.lastIndexOf(" ")));
    this.selectedValueSA = this.selectedValueSA + '...';
    this.selectedValueSA = this.sanitizeHTML(this.selectedValueSA);
  }

  async toggleFindMoreSA() {
    this.showSa = true;
    this.selectedValueSA = this.sanitizeHTML(this.findOutMoreSA);
    this.createCase(this.selectedValueSA, this.articleTitleSA, "SA");
  }

  viewArticleAr(id) {
    if (this.showAr == false)
      this.homeService.getViewArticles(id).subscribe(res => {
        let article = res.return_body.article
        this.articleTitleAR = article.article_title;
        this.findOutMoreAR = article.article_content;
        if (this.findOutMoreAR.includes("${runtime")) {
          this.homeService.getContact().subscribe(res => {
            this.contact = res.return_body;
            console.log("contact ", this.contact);
            let val = [];
            let contact = []
            contact = res.return_body;
            console.log("contact temp is ", contact);
            val = res.return_body.ute;

            console.log("value is", val)
            for (const line of this.findOutMoreAR.split(/[\r\n]+/)) {
              if (line.includes("${runtime")) {
                this.count++;
                for (let value of val) {
                  value.registry_key = value.registry_key.replaceAll(" ", "_");
                  if (line.includes("${runtime.custom_" + value.registry_key)) {
                    if (!(value.attribute_type == "OPTION" || value.attribute_type == "MULTIOPTION")) {
                      console.log("value appended");
                      this.appendedData = this.findOutMoreAR.replaceAll("${runtime.custom_" + value.registry_key + "}", value.field_value);
                      this.findOutMoreAR = this.appendedData;
                    }
                    else {
                      this.homeService.getCaller(value.id).subscribe(response => {
                        this.result = response.return_body;
                        for (let optionValue of this.result) {
                          if (value.attribute_type === "OPTION" && value.attribute_type != "MULTIOPTION") {
                            if (value.field_value.includes(optionValue.id.toString())) {
                              this.appendedData = this.findOutMoreAR.replaceAll("${runtime.custom_" + value.registry_key + ".optionvalue" + "}", optionValue.option_value);
                              this.findOutMoreAR = this.appendedData;
                            }

                          }
                          if (value.attribute_type === "MULTIOPTION" && value.attribute_type != "OPTION") {
                            let tempValues = []
                            let temp = []
                            if (value.field_value.includes(",")) {
                              tempValues = tempValues.concat(value.field_value);
                              value.field_value.split(",")
                              for (let option of this.result) {
                                for (let field of tempValues) {
                                  if (field.includes(option.id.toString())) {
                                    temp = temp.concat(option.option_value);
                                  }
                                }
                              }
                              this.appendedData = this.findOutMoreAR.replaceAll("${runtime.custom_" + value.registry_key + ".optionvalue" + "}", temp);
                              this.findOutMoreAR = this.appendedData;
                            }
                            else {
                              if (value.field_value.includes(optionValue.id.toString())) {
                                this.appendedData = this.findOutMoreAR.replaceAll("${runtime.custom_" + value.registry_key + ".optionvalue" + "}", optionValue.option_value);
                                this.findOutMoreAR = this.appendedData;
                              }
                            }

                          }

                        }
                        this.showLessDataAR(this.findOutMoreAR);
                      });

                    }

                  }
                  if (line.includes("${runtime.caller_")) {
                    if (line.includes("${runtime.caller_firstname")) {
                      this.appendedData = this.findOutMoreAR.replaceAll("${runtime.caller_firstname}", res.return_body.first_name);
                      this.findOutMoreAR = this.appendedData;

                    }
                    if (line.includes("${runtime.caller_lastname")) {
                      this.appendedData = this.findOutMoreAR.replaceAll("${runtime.caller_lastname}", res.return_body.last_name);
                      this.findOutMoreAR = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_username")) {
                      this.appendedData = this.findOutMoreAR.replaceAll("${runtime.caller_username}", res.return_body.user_name);
                      this.findOutMoreAR = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_email")) {
                      this.appendedData = this.findOutMoreAR.replaceAll("${runtime.caller_email}", res.return_body.email);
                      this.findOutMoreAR = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_userid")) {
                      this.appendedData = this.findOutMoreAR.replaceAll("${runtime.caller_userid}", res.return_body.user_id);
                      this.findOutMoreAR = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_phone")) {
                      this.appendedData = this.findOutMoreAR.replaceAll("${runtime.caller_phone}", res.return_body.primary_phone);
                      this.findOutMoreAR = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_extra_userid")) {
                      this.appendedData = this.findOutMoreAR.replaceAll("${runtime.caller_extra_userid}", res.return_body.extra_user_id);
                      this.findOutMoreAR = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_campus")) {
                      this.appendedData = this.findOutMoreAR.replaceAll("${runtime.caller_campus}", res.return_body.campus);
                      this.findOutMoreAR = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_dob")) {
                      this.appendedData = this.findOutMoreAR.replaceAll("${runtime.caller_dob}", res.return_body.dob);
                      this.findOutMoreAR = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_ssn")) {
                      this.appendedData = this.findOutMoreAR.replaceAll("${runtime.caller_ssn}", res.return_body.ssn);
                      this.findOutMoreAR = this.appendedData;
                    }
                    if (line.includes("${runtime.caller_password")) {
                      this.appendedData = this.findOutMoreAR.replaceAll("${runtime.caller_password}", res.return_body.password);
                      this.findOutMoreAR = this.appendedData;
                    }
                  }
                }
              }
            }
          });

        }
        else {
          this.showLessDataAR(this.findOutMoreAR);
        }
      });
  }

  showLessDataAR(data) {
    this.selectedValueAR = data?.slice(0, 300);
    this.selectedValueAR = this.selectedValueAR.substr(0, Math.min(this.selectedValueAR.length, this.selectedValueAR.lastIndexOf(" ")));
    this.selectedValueAR = this.selectedValueAR + '...';
    this.selectedValueAR = this.sanitizeHTML(this.selectedValueAR);
  }

  async toggleFindMoreAR() {
    this.showAr = true;
    this.selectedValueAR = await this.sanitizeHTML(this.findOutMoreAR);
    this.createCase(this.selectedValueAR, this.articleTitleAR, "AR");
  }

  createCase(content, title, type) {
    const data = new TrackerCaseCreation();
    data.trackerData = content;
    data.trackerTitle = title;
    data.trackerType = type;
    data.userPk = this.authService.getCurrentUserPK();

    this.homeService.trackerCase(data).subscribe(res => {
      this.createdTicket = res.return_body;
    })
  }


  sanitizeHTML(articleData) {
    if (articleData.includes('<iframe')) {
      console.log("article data is", articleData);
      let articleViewValue = this.domSanitizer.bypassSecurityTrustHtml(articleData);
      return articleViewValue;
    }
    else {
      return articleData;
    }
  }

  getHeaderConfig() {
    this.homeService.getHeaderConfig().subscribe(res => {
      this.header = res.return_body;
      this.linkText = this.header.headerHyperLink.linkText
    });
  }

  caseMessage() {
    this.caseAlertMessage = sessionStorage.getItem('alertMessage')
    if (this.caseAlertMessage) {
      this.alert = true
    }
    setInterval(() => {
      this.delayed = true
      this.alert = false
      sessionStorage.removeItem('alertMessage')
    }, 5000);
  }

  handleNavigation() {
    this.router.navigate([this.router.url.split("/")[1], 'home']);
  }

  kbSearchConfig() {
    this.homeService.getKbSearchConfiguration().subscribe(res => {
      this.searchBanner = res.return_body.searchBanner;
      this.searchTextboxNote = res.return_body.searchTextboxNote;
      this.searchTextboxHover = res.return_body.searchTextboxHoverNote;
      this.searchButtonHover = res.return_body.searchButtonHoverNote;
    });
  }

  selectEvent(item) {
    this.selectedValue = item.name;
    this.search(this.selectedValue);
  }

  onChangeSearch(val: string) {
    this.selectedValue = val;
    this.data = [];
    if (val != '') {
      this.homeService.getSearchData(val).subscribe(res => {
        this.data = [];
        res.return_body.map((response, index) => {
          this.data.push({ id: index, name: response });
        })
      });
    }
  }

  onFocused(e) {
    this.data = [];
  }

  search(selectedValue) {
    this.router.navigate(['/' + this.router.url.split('/')[1] + '/searchresults'], { queryParams: { selectedValue: selectedValue, currentPage: 0 } });
  }
  onKeyEnterSearch(event: any, searchkeyWrd: any) {
    this.search(searchkeyWrd);
  }

  searchCleared() {
    this.selectedValue = '';
  }

  createCaseLink() {
    // this.router.navigate([this.router.url.split("/")[1], 'createcase']);
    this.checkCaseModalInHelpCenter = true;
  }

  checkIsCaseModalOpen(event) {
    this.checkCaseModalInHelpCenter = false;
  }

  openChat() {
    this.homeService.openChat.next(true);
  }

  navigationLink() {
    this.router.navigate([this.router.url.split("/")[1], 'helpcenter']);
  }

  handleTrackerNavigation() {
    if (this.showOnSelfHelp == true) {
      this.router.navigate([this.router.url.split("/")[1], 'tracker']);
    }
  }

}